import {
  Card,
  CardActionArea,
  CardContent,
  Divider,
  Stack,
  Typography,
} from '@mui/material'
import { IconButton, Icons } from 'utoniq-ui'

import { Item } from '@/clients/utoniq-core/schema'
import { styleSets } from '@/components/styles'
import { useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'

import { ApplyPreSaleLotteryValue } from '../LotteryDetailForm'

type SkuUnitSelectModalProps = {
  isBeforeReceiption: boolean
  item: Partial<Item>
  selectedItems: ApplyPreSaleLotteryValue['choices']
  onClose: () => void
  onGoBack: () => void
  onSelectItem: (skuId: string | undefined) => void
}

export const SkuUnitSelectModal: Organism<SkuUnitSelectModalProps> = ({
  isBeforeReceiption,
  item,
  selectedItems,
  onClose,
  onGoBack,
  onSelectItem,
}) => {
  const { t } = useTranslation('lotteryDetail')
  const skuUnits = item?.skuSettings?.units

  return (
    <OrganismFrame
      sx={{
        bgcolor: 'background.default',
        height: '75dvh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Stack direction="row" sx={{ py: 4, px: 3 }} alignItems="center">
        <IconButton.Back size="small" onClick={onGoBack} />
        <Typography variant="h6" align="center" width="100%">
          {t('selectTicketTitle', 'チケットを選択')}
        </Typography>
        <IconButton.Close size="small" onClick={onClose} />
      </Stack>
      <Divider />
      <Typography
        variant="h5"
        width="100%"
        color="text.secondary"
        sx={{ bgcolor: 'grey.50', px: 5, py: 1 }}
      >
        {t('performanceInformation', '公演情報')}
      </Typography>
      <Typography variant="body2" width="100%" sx={{ px: 5, py: 2 }}>
        {item?.title}
      </Typography>
      <Typography
        variant="h5"
        width="100%"
        color="text.secondary"
        sx={{ bgcolor: 'grey.50', px: 5, py: 1, mt: 3 }}
      >
        {t('typeSelection', '種類選択')}
      </Typography>
      <Stack
        flex={1}
        spacing={2}
        sx={{ p: 5, overflowY: 'auto', ...styleSets.hideScrollbar() }}
      >
        {skuUnits?.map(itemSku => {
          const selectedItemIndex = selectedItems.findIndex(
            selectedItem => selectedItem.skuId === itemSku?.id
          )
          const isSelectedItem = selectedItemIndex >= 0
          return (
            <Stack key={itemSku?.id}>
              <Card
                elevation={0}
                sx={{
                  borderRadius: 2,
                  bgcolor: 'grey.50',
                }}
              >
                <CardActionArea
                  disabled={isSelectedItem || isBeforeReceiption}
                  onClick={() => onSelectItem(itemSku.id)}
                >
                  <CardContent sx={{ px: 5, py: 2, '&:last-child': { pb: 4 } }}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography
                        variant="subtitle1"
                        color={
                          isSelectedItem || isBeforeReceiption
                            ? 'text.disabled'
                            : 'text.primary'
                        }
                      >
                        {itemSku?.unitName}
                      </Typography>
                      {isSelectedItem && (
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Icons.Check fontSize="small" color="primary" />
                          <Typography variant="subtitle1" color="primary.main">
                            {t('selectedIndex', {
                              number: selectedItemIndex + 1,
                            })}
                          </Typography>
                        </Stack>
                      )}
                    </Stack>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Stack>
          )
        })}
      </Stack>
    </OrganismFrame>
  )
}
